<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/budget-widget/budget-widget.component.ts
-->
<ng-template #anchor></ng-template>
